// The hidden `.player-select` must hold an <option> for whoever a module shows: Undo reads
// the player off it, and a linked pick asks it whether this module offers her (05c). A
// live pick (ids-3) can be a player the snapshot doesn't have, so her option is added the
// first time a picker takes her.

import { getPlayerShortName } from "../data/player-utils.js";
import type { PickedPlayer } from "../live/picked-players.js";

export function hasPlayerOption(select: HTMLSelectElement, id: number): boolean {
  const value = String(id);
  return Array.from(select.options).some((o) => o.value === value);
}

/** Add her option (name as its text, name + team to search) unless it's there already. */
export function ensurePlayerOption(select: HTMLSelectElement, p: PickedPlayer): void {
  if (hasPlayerOption(select, p.id)) return;
  // The box shows the name she's known by ("Lionel Messi"); the search still finds the legal one.
  const shown = getPlayerShortName(p);
  const option = new Option(shown, String(p.id));
  option.dataset.search = [shown, p.name, p.team].filter(Boolean).join(" ");
  select.add(option);
}
